import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { TitleCard } from '../components/TitleCard';
import { getTopRequests } from '../services/api';
import { Title } from '../types';

export const TopRequests: React.FC = () => {
    const [titles, setTitles] = React.useState<Title[]>([]);

    React.useEffect(() => {
        const fetchData = async () => {
            const data = await getTopRequests();
            setTitles(data);
        };
        fetchData();
    }, []);

    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Top Requested Adaptations
            </Typography>
            <Typography variant="body1" paragraph>
                These are the most requested shows and movies from our community in the past 24 hours.
            </Typography>

            <Grid container spacing={3}>
                {titles.map((title) => (
                    <Grid item xs={12} sm={6} md={4} key={title.id}>
                        <TitleCard title={title} showVotes />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};